import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';
import { loggerService } from 'shared/lib/logger';

import { getFreeToPaidBffUrl } from './constants';
import { CodeInfo } from './types';

export const freeToPaidBffApi = createApi({
  reducerPath: 'free-to-paid-bff',
  baseQuery: baseQuery(getFreeToPaidBffUrl),
  endpoints: (builder) => ({
    getCodeInfo: builder.query<CodeInfo, string | undefined>({
      query: (code) => `code/${code}`,
      async onQueryStarted(code, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (e) {
          loggerService.logError('Class code info loading error', e);
        }
      },
    }),
  }),
});

export const { useLazyGetCodeInfoQuery } = freeToPaidBffApi;
